import { render, staticRenderFns } from "./SignatureFarms.vue?vue&type=template&id=556e9b32&scoped=true&"
import script from "./SignatureFarms.vue?vue&type=script&lang=js&"
export * from "./SignatureFarms.vue?vue&type=script&lang=js&"
import style0 from "./SignatureFarms.vue?vue&type=style&index=0&id=556e9b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556e9b32",
  null
  
)

export default component.exports